import { render, staticRenderFns } from "./relate_form.vue?vue&type=template&id=0920287c&scoped=true&"
import script from "./relate_form.vue?vue&type=script&lang=js&"
export * from "./relate_form.vue?vue&type=script&lang=js&"
import style0 from "./relate_form.vue?vue&type=style&index=0&id=0920287c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920287c",
  null
  
)

export default component.exports